import { extractProperties } from '../../utils/extractProperties';
export function parseFlexValue(flexShorthand) {
    if (!flexShorthand)
        return {};
    if (typeof flexShorthand === 'number') {
        return {
            flexGrow: flexShorthand,
            flexShrink: 1,
            flexBasis: 'auto',
        };
    }
    if (flexShorthand === 'grow') {
        return {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 'auto',
        };
    }
    if (flexShorthand === 'shrink') {
        return {
            flexGrow: 0,
            flexShrink: 1,
            flexBasis: 'auto',
        };
    }
    if (flexShorthand === 'none') {
        return {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: 'auto',
        };
    }
    const flexProperties = flexShorthand.split(' ');
    return flexProperties.reduce((props, currentProp, index) => {
        if ((index === 0 || index === 1) && isNumber(currentProp)) {
            props[index === 0 ? 'flexGrow' : 'flexShrink'] = currentProp;
        }
        else {
            props.flexBasis = currentProp;
        }
        return props;
    }, {});
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}
export function getBoxRestrictedProperties(props) {
    return extractProperties(props, [
        'alignSelf',
        'justifySelf',
        'flex',
        'flexBasis',
        'order',
        'gridArea',
        'gridColumn',
        'gridColumnStart',
        'gridColumnEnd',
        'gridRow',
        'gridRowStart',
        'gridRowEnd',
        'margin',
        'marginBlock',
        'marginBlockStart',
        'marginBlockEnd',
        'marginInline',
        'marginInlineStart',
        'marginInlineEnd',
        'width',
        'maxWidth',
        'minWidth',
        'height',
        'maxHeight',
        'minHeight',
        'position',
        'inset',
        'insetBlock',
        'insetBlockStart',
        'insetBlockEnd',
        'insetInline',
        'insetInlineStart',
        'insetInlineEnd',
        'verticalAlign',
        'zIndex',
        'hidden',
        'UNSAFE_hideWhenEmpty',
    ]);
}
//# sourceMappingURL=BoxUtils.js.map